module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progressHandOver flexcenter"
  }, [_c('transition', [_c('div', {
    staticClass: "handOver flexcenter"
  }, [_c('div', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lbold font20 modal-title"
  }, [_vm._v("このアクティビティに現在の進捗度を引き継ぎますか？")]), _vm._v(" "), _c('button', {
    staticClass: "reset",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clickButton(false)
      }
    }
  }, [_c('span', {
    staticClass: "font17 lbold"
  }, [_vm._v("いいえ")]), _c('span', {
    staticClass: "font13 block"
  }, [_vm._v("(リセットしてやり直す)")])]), _vm._v(" "), _c('button', {
    staticClass: "yes",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clickButton(true)
      }
    }
  }, [_c('span', {
    staticClass: "font17 lbold"
  }, [_vm._v("はい")]), _c('span', {
    staticClass: "font13 block"
  }, [_vm._v("(現在の進捗を引き継ぐ)")])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a3110bd0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-a3110bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressHandOver.vue
// module id = 640
// module chunks = 1